import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Card, CardHeader, Container, Row, Button, Modal, ModalHeader, ModalBody, ModalFooter,Input, Label } from "reactstrap";
import { getOrdersNotCollected,markCollected } from "network/ApiAxiosTickets"
import axios from "axios";

import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { updateOrder } from "network/ApiAxiosTickets";
import { selfSalesAll } from "network/ApiAxiosTickets";
import { getMainEventInfo } from "network/ApiAxiosEventsGetickets";
import { deleteOrder } from "network/ApiAxiosTickets";
import { updateOrderNotes } from "network/ApiAxiosTickets";
import { updateOrderQuantity } from "network/ApiAxiosTickets";
import { selfSalesPaid } from "network/ApiAxiosTickets";

const PastOrders = () => {
  const history = useHistory();
  const [orders, setOrders] = useState();
  const [modal, setModal] = useState(false);
  const [orderToEdit, setOrderToEdit] = useState();
  const [tempOrderToEdit, setTempOrderToEdit] = useState();
  const [reload, setReload] = useState("");
  const [mainEventInfo, setMainEventInfo] = useState(null);

  const role = JSON.parse(localStorage.getItem("user")).role
  const sellerID = JSON.parse(localStorage.getItem("user"))._id

  const toggle = () => setModal(!modal);
  
  useEffect(() => { 
    const runAsync = async () => {
      //const response = await getOrdersNotCollected("userTable");
      const response = await selfSalesPaid(sellerID)
      const { data } = response;
      if (data.success) {
        setOrders(data.doc);
        fetchMainEventInfo(data.doc)
      }
    };
    runAsync();
  }, [reload]);

  function editOrder(e) {
    console.log(e.data)
    setOrderToEdit(e.data)
    setTempOrderToEdit(e.data)
    toggle()
  }

  const fetchMainEventInfo = async(e)=>{
    const ArrayPromises = []
    e.map((orderItem)=>{
        orderItem.cart.map((cartItem)=>{
            console.log('first promise--',cartItem.mainEventId)
            ArrayPromises.push(getMainEventInfo(cartItem.mainEventId))
        })
    })
    console.log(ArrayPromises)
    Promise.all(ArrayPromises).then((resp)=>{
        console.log(resp)
        setMainEventInfo(resp.map((respItem)=>{
            return {[respItem.data.event._id] : respItem.data.event.name}
        }))
        console.log('final---',resp.map((respItem)=>{
            return {[respItem.data.event._id] : respItem.data.event.name}
        }))
        console.log('final---',mainEventInfo)
    }).catch((err)=> console.log('main event fetch error',err))
    /*
      const resp = await getMainEventInfo(e)
      if(resp.data.success){
        console.log('main event info ---',resp.data.event)
        //return resp.data.event
      }
        */
  }

  const getRowStyle = (params) => {
    console.log('sssss--',params.data.deleted)
    if(params.data.deleted){
      return { background: 'red'}
    }
    if (params.node.rowIndex % 2 === 0) {
      return { background: "aliceblue" };
    }
  };

  const [gridApi, setGridApi] = useState(null);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  return (
    <>
      <Container>
        <Row>
          <div className="col">
            <Card className="shadow" style={{ width:"100%"}}>
              <CardHeader>
                <p>Double click to open order</p>
              </CardHeader>
              <div className="ag-theme-alpine" style={{ height: 500, width:"100%"}}>
              
                <AgGridReact
                  rowData={orders}
                  animateRows={true}
                  onRowDoubleClicked={editOrder}
                  pagination={true}
                  paginationPageSize={20}
                  getRowStyle={getRowStyle}
                  onGridReady={onGridReady}
                  defaultColDef={{
                    flex: 1,
                    filter: true,
                    sortable: true,
                    floatingFilter: true,
                    columnHoverHighlight: true,
                    resizable: true,
                    suppressDragLeaveHidesColumns: false,
                  }}
                >
                  
                  <AgGridColumn field="clientName" minWidth="150" quickFilterText style={{textAlign:"center"}}></AgGridColumn>
                  <AgGridColumn field="phone" minWidth="200"></AgGridColumn>
                  <AgGridColumn field="total" headerName="Total" minWidth="80" filter="agNumberColumnFilter"></AgGridColumn>
                  <AgGridColumn
                    field="createdAt"
                    headerName="Date (Time add 1H)"
                    minWidth="200"
                  ></AgGridColumn>
                </AgGridReact>
              </div>
            </Card>

            <Modal isOpen={modal} toggle={toggle}>
              <ModalHeader toggle={toggle}>Order</ModalHeader>
              <ModalBody className="text-center">
                {orderToEdit && <>
                  <h3>Client Name:</h3> <p>{orderToEdit.clientName}</p>
                  <h3>Cart:</h3> 
                  {tempOrderToEdit && tempOrderToEdit.cart.map((cartItem)=>{
                    return <Row key={cartItem._id} className="d-flex justify-content-center" >
                            <Label className=" align-self-center" > { cartItem.qt + ' X ' + ' ' + cartItem.checkinFrom.split('T')[0] + ' ' + Object.values(mainEventInfo.find((value) => Object.keys(value) == cartItem.mainEventId))[0] } 
                            </Label> 
                        </Row>
                  })}
                  <h3>Order Date:</h3> <p>{orderToEdit.createdAt.split('T')[0]}</p>
                  <h3>Total:</h3> <p>{orderToEdit.total}</p>
                  <h3>Notes:</h3> <p>{tempOrderToEdit?.notes}</p>
                  {
                    orderToEdit && <img src={'https://celebrationjump.com/public/whatsapptemp/' + orderToEdit._id + '.jpg'} ></img>
                  }
                </>}
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={toggle}>Close</Button>
              </ModalFooter>
            </Modal>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default PastOrders;
